import AccountCreation from "@/components/signup/account-creation";
import {
    SignupBackgroundLayout,
    JSMOverlayTemplate
} from "@/components/signup/layouts";
import { ProductKey, ServiceCollectionLogo } from "@/components/signup/utils";
import { experiments, ExperimentView } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { useLocation } from "@/utils/location-provider";

import {
    FreeForThreeAgentsText,
    GetStartedHeading,
    GetStartedText,
    Headings,
    SubHeading,
    YourPlanIncludesText,
    JSMGetStartedHeading,
    JSMGetStartedText,
    InputSubmitButton
} from "../components";

const JSM_PRODUCT_NAME = "Jira Service Management";

const useIsJsmCrossflow = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    return (
        params.get("primaryCollectionProduct") ===
        ProductKey.JIRA_SERVICE_MANAGEMENT
    );
};

const LoggedOutContent = ({
    identityCobranding
}: {
    identityCobranding: string;
}) => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<GetStartedText productName="Service Collection" />}
                    sub={<FreeForThreeAgentsText />}
                />
            ) : (
                <>
                    <GetStartedHeading productName="Service Collection" />
                    <SubHeading>
                        <FreeForThreeAgentsText />
                    </SubHeading>
                </>
            )}
            <AccountCreation identityCobranding={identityCobranding} />
        </>
    );
};

const LoggedOutContentLofi = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    const isJsmCrossflow = useIsJsmCrossflow();
    const heading = isJsmCrossflow ? (
        <GetStartedHeading productName={JSM_PRODUCT_NAME} />
    ) : (
        <JSMGetStartedHeading />
    );
    const headingMain = isJsmCrossflow ? (
        <GetStartedText productName={JSM_PRODUCT_NAME} />
    ) : (
        <JSMGetStartedText />
    );
    return (
        <>
            {team26VisualUpdates ? (
                <Headings main={headingMain} sub={<YourPlanIncludesText />} />
            ) : (
                <>
                    {heading}
                    <SubHeading>
                        <YourPlanIncludesText />
                    </SubHeading>
                </>
            )}
            <AccountCreation
                Input={<InputSubmitButton />}
                Submit={null}
                identityCobranding="wac--service-collection-cobranding"
            />
        </>
    );
};

export const LoggedOut = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <LoggedOutContentLofi />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <LoggedOutContent identityCobranding="wac--service-collection" />
                </SignupBackgroundLayout>
            )
        }
    />
);
